import createReactClass from 'create-react-class';
// -*- mode: jsx;-*-

export const RecurringDonationIllustration = createReactClass({
    propTypes: {
    },

    statics: {
        MONTHS: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    },

    getThisMonth: function () {
        var d = new Date();
        return (
            this.constructor.MONTHS[d.getMonth()]
        );
    },

    getNextMonth: function () {
        var d = new Date();
        if (d.getMonth() === 11) {
            return (
                this.constructor.MONTHS[0]
            );
        } else {
            return (
                this.constructor.MONTHS[d.getMonth() + 1]
            );
        }
    },

    getLastMonth: function () {
        var d = new Date();
        if (d.getMonth() === 0) {
            return (
                this.constructor.MONTHS[11]
            );
        } else {
            return (
                this.constructor.MONTHS[d.getMonth() - 1]
            );
        }
    },

    render: function () {
        return (
            <div>
                <div className="illustrate-monthly">
                    <div className="month last-month">
                        <div className="month-name">{this.getLastMonth()}</div>
                        <div className="stamp-spot">
                            <img className="illustration microscope" src={baseCacheURL + 'images/recurringdonationlanding/single-icon-microscope.png'} alt=""/>
                        </div>
                    </div>
                    <div className="month this-month">
                        <div className="month-name">{this.getThisMonth()}</div>
                        <div className="stamp-spot">
                            <img className="illustration book" src={baseCacheURL + 'images/recurringdonationlanding/single-icon-book.png'} alt=""/>
                        </div>
                    </div>
                    <div className="month next-month">
                        <div className="month-name">{this.getNextMonth()}</div>
                        <div className="stamp-spot">
                        </div>
                    </div>
                </div>
            </div>
        );
    },
});
